import _noop from 'lodash/noop';
import type { Navigation, NavigationItem } from '../types';

// In Navigation Preview , we want all the navItemsUrl to be disabled
export const getPreviewNavItems = (navigation: Navigation, disabled: boolean) => {
  if (!disabled) {
    return navigation;
  }

  const adaptNavItem = (item: NavigationItem) => {
    const { type } = item;

    switch (type) {
      // CUSTOM AND LABEL are rendered only in LiteSideNavigation
      case 'CUSTOM':
      case 'LABEL':
      case 'COLOR_SCHEME_SWITCHER':
      case 'LANGUAGE_SWITCHER':
      case 'BUTTON':
      case 'APPLICATION_PAGE':
        return item;
      case 'USER_MENU':
        return { ...item, disabled: true };
      case 'ACTION':
        return { ...item, onClick: _noop };
      case 'URL':
        return { ...item, readonly: true };
      default:
        return {
          ...item,
          items: item.items.map((subItem) => ({
            ...subItem,
            readonly: true,
          })),
        };
    }
  };

  return {
    primary: navigation.primary.map(adaptNavItem) as Navigation['primary'],
    secondary: navigation.secondary?.map(adaptNavItem) as Navigation['secondary'],
  };
};
